import { BASE_URL } from '../constants/url'
import { client } from './baseService'

export const getHeatMapByCompanyId = async (companyId: string, rangeSize: string = '1d') => {
  try {
    const res = await client().get(`${BASE_URL}/heatmap/${companyId}?rangeSize=${rangeSize}`)
    return res.data
  } catch (error) {}
}
